import { BaseEntity } from '@ianesthesie-kit/services';
import { Risk } from '@/modules/surgicalEvent';

export type SurgerySeverity =
  | Risk
  | 'VERY_LOW'
  | 'VERY_HIGH'
  | 'NOT_APPLICABLE';

export interface Surgery extends BaseEntity {
  code: string;
  translationCode: string;
  severity: SurgerySeverity;
  supportsLaterality: boolean;
  obstetrics: boolean;
  localFacingName?: string;
}

const severityOrder: Record<SurgerySeverity, number> = {
  NOT_APPLICABLE: 0,
  VERY_LOW: 1,
  LOW: 2,
  MEDIUM: 3,
  HIGH: 4,
  VERY_HIGH: 5
};

export function sortSeverity(
  a: SurgerySeverity | undefined,
  b: SurgerySeverity | undefined
) {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }

  return severityOrder[a] - severityOrder[b];
}

export function maxSeverity(...severities: (SurgerySeverity | undefined)[]) {
  return (
    severities?.filter(Boolean).sort(sortSeverity).at(-1) ?? 'NOT_APPLICABLE'
  );
}
